module.exports = __webpack_public_path__ + "static/media/whitevisa.c5399f28.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/whitevisa.png
// module id = 481
// module chunks = 0